export default __webpack_public_path__ + "static/media/neoply_isms.3616c24c.pdf";